const moment = require('moment-timezone')

const formatDateUk = date =>
  date && moment(date).tz('Europe/London').format('HH:mm D MMM YYYY')

export default formatDateUk
